import { Article, P } from '@slal/ui/typography';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { BackButton, MaxWidthContent } from '~/components';
import { useAnalytics, useApplicationSessionBack } from '~/hooks';
import { SubmitButton } from '..';
import { StyledApplicationButtonsWrapper } from '../styles';

export const KeyConsiderationsInformation = () => {
    const navigate = useNavigate();
    const { pushEvent } = useAnalytics();
    const backRoute = useApplicationSessionBack('key-considerations-information');
    const navigateNext = useCallback(() => {
        navigate('/application/key-considerations/main-plan');
        pushEvent({ eventLabel: 'Next button click' });
    }, [navigate, pushEvent]);
    return (
        <MaxWidthContent>
            <Article>
                <P>
                    Before you continue, we just want to ask some questions to make sure you're aware of any potential
                    risks, so you're confident taking money from your pension.
                </P>

                <P>There are no right or wrong answers, and this information is completely confidential.</P>
            </Article>

            <StyledApplicationButtonsWrapper>
                <SubmitButton onClick={navigateNext} />
                <BackButton route={backRoute} />
            </StyledApplicationButtonsWrapper>
        </MaxWidthContent>
    );
};
